import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import Loader from '../../components/Loader/index';
import { login } from '../../middlewares/Authentication';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import ReduxToastr from 'react-redux-toastr';

const AuthApp = Loadable({
  loader: () => import('./AuthApp'),
  loading: () => <Loader />
});
const AuthError = Loadable({
  loader: () => import('./AuthError'),
  loading: () => <Loader />
});
const AuthSwitchGroup = Loadable({
  loader: () => import('./AuthSwitchGroup'),
  loading: () => <Loader />
});
class App extends Component {
  render() {
    return (
      <div className="app">
        <Switch>
          <Route path="/login" component={() => <div>{() => login()}</div>} />
          <Route path="/error" component={AuthError} />
          <Route path="/switch" component={AuthSwitchGroup} />
          <Route path="/" component={AuthApp} />
        </Switch>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-center"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick
        />
      </div>
    );
  }
}

export default App;
